import React from 'react';
import {
  Box,
  Typography,
  Switch,
  Avatar,
  useTheme,
  Tooltip,
} from '@mui/material';
import { LightMode as LightModeIcon, DarkMode as DarkModeIcon } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { toggleTheme, setThemeVariant } from '../../../store/actions/themeActions';
import { getVariantsForMode } from '../../../config/themeConfig';
import { styles } from './ThemeVariantSelectorCss';

const ThemeVariantSelector = ({ isDropdown = false }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const themeMode = useSelector(state => state.theme.mode);
  const themeVariant = useSelector(state => state.theme.variant);

  const isDark = themeMode === 'dark';
  const variants = getVariantsForMode(themeMode);

  const handleModeToggle = () => {
    dispatch(toggleTheme());
  };

  const handleVariantSelect = (key) => {
    dispatch(setThemeVariant(key));
  };

  return (
    <Box sx={styles.container(theme, isDropdown)}>
      {/* Mode Toggle Section */}
      <Box sx={styles.modeToggleSection(isDropdown)}>
        <Box sx={styles.modeToggleLeft}>
          <Avatar sx={styles.modeAvatar(theme, isDark, isDropdown)}>
            {isDark ? <DarkModeIcon /> : <LightModeIcon />}
          </Avatar>
          <Box>
            <Typography variant="h6" sx={styles.modeTitle(isDropdown, theme)}>
              {isDark ? 'Dark Mode' : 'Light Mode'}
            </Typography>
          </Box>
        </Box>
        <Switch
          checked={isDark}
          onChange={handleModeToggle}
          color="primary"
          sx={styles.switchStyles(theme)}
        />
      </Box>

      {/* Variant Selection Section */}
      <Box sx={styles.variantSection(theme, isDropdown)}>
        <Typography variant="body2" sx={styles.variantTitle(isDropdown, theme)}>
          Theme Variant
        </Typography>
        <Box sx={styles.variantContainer(isDropdown)}>
          {variants.map((v) => {
            const isSelected = themeVariant === v.key;
            return (
              <Box key={v.key} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                <Tooltip title={v.label}>
                  <Box
                    onClick={() => handleVariantSelect(v.key)}
                    sx={styles.variantCircle(theme, v, isSelected, isDropdown)}
                  >
                    <Box sx={styles.innerCircle(v, isDropdown)} />
                  </Box>
                </Tooltip>
                <Typography variant="caption" sx={styles.variantLabel(isDropdown, isSelected, theme)}>
                  {v.label.split(' ')[0]}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default ThemeVariantSelector;
